

import { CampaignModel, EPartialInfoPool, ListCampaignModel, ListModel, ListsFactory, SendersFactory, TCampaignReport, TListModel, TPromisePool, TPromisePoolPartialCampaignReports, TPromisePoolPartialList, TPromisePoolPartialListReport, TPromisePoolPartialSender, TPromisePoolPartialTemplates, TPromisePoolPartialUser, TSystemEmail, TemplatesFactory, UserModel, UsersFactory, startPromisePool } from "@cakemail-org/ui-components-v2"

export async function systemEmailTemplatesPromissePool({ data, setter, ...rest }: TPromisePool<TSystemEmail, TPromisePoolPartialTemplates>) {
    return startPromisePool({
        ...rest,
        data: data.filter((s) => s.template?.id),
        setter,
        dataIdPath: "template.id",
        storageKey: EPartialInfoPool.partialTemplates,
        processor: ({ processSetter, item }) => {
            return TemplatesFactory.get({ id: Number(item.template?.id) })
                .then((data) => {
                    const partialResults = {
                        name: data.name,
                        description: data.description,
                        thumbnail_url: data.thumbnail_url
                    }
                    processSetter(partialResults)
                    return partialResults
                })
                .catch(() => { return undefined })
        }
    })
}

export async function systemEmailSenderPromissePool({ data, setter, ...rest }: TPromisePool<TSystemEmail, TPromisePoolPartialSender>) {
    return startPromisePool({
        ...rest,
        data: data.filter((s) => s.sender?.id),
        setter,
        dataIdPath: "sender.id",
        storageKey: EPartialInfoPool.partialSenders,
        processor: ({ processSetter, item }) => {
            return SendersFactory.get({ id: Number(item.sender?.id) })
                .then((data) => {
                    const partialResults = {
                        email: data.email,
                        name: data.name,
                        confirmed: data.confirmed
                    }
                    processSetter(partialResults)
                    return partialResults
                })
                .catch(() => { return undefined })
        }
    })
}


export async function listsPromisePool({ data, setter, ...rest }: TPromisePool<Partial<TListModel>, TPromisePoolPartialList>) {
    return startPromisePool({
        ...rest,
        data,
        setter,
        storageKey: EPartialInfoPool.partialLists,
        processor: ({ processSetter, item }) => {
            return ListsFactory.get({ id: Number(item.id) })
                .then((data) => {
                    const partialResults = {
                        name: data.name,
                        status: data.status,
                        id: data.id
                    }
                    processSetter(partialResults)
                    return partialResults
                })
                .catch(() => { return undefined })
        }
    })
}

export async function listReportsPromisePool({ data, setter, ...rest }: TPromisePool<ListModel, TPromisePoolPartialListReport>) {
    return startPromisePool({
        ...rest,
        data,
        setter,
        storageKey: EPartialInfoPool.partialListReports,
        processor: ({ processSetter, item }) => {
            return item.getReport()
                .then((data) => {
                    const partialResults = {
                        active_contacts: data.active_contacts,
                        open_rate: data.open_rate,
                        click_rate: data.click_rate
                    }
                    processSetter(partialResults)
                    return partialResults
                })
                .catch(() => { return undefined })
        }
    })
}

export async function campaignReportsPromisePool({ data, setter, ...rest }: TPromisePool<ListCampaignModel, TPromisePoolPartialCampaignReports>) {
    return startPromisePool({
        ...rest,
        data,
        setter,
        storageKey: EPartialInfoPool.partialCampaignReports,
        processor: ({ processSetter, item }) => {
            if (!["delivered", "scheduled", "delivering"].includes(item.status)) return undefined

            return item?.getReport()?.then((data) => {
                const partialResults = {
                    open_rate: data.data.open_rate,
                    click_rate: data.data.click_rate,
                    unsubscribe_rate: data.data.unsubscribe_rate,
                    spam_rate: data.data.spam_rate,
                    bounce_rate: data.data.bounce_rate,
                    unique_clicks: data.data.unique_clicks,
                    unique_opens: data.data.unique_opens
                }
                processSetter(partialResults)
                return partialResults
            })
                .catch(() => { return undefined })
        }
    })
}